// Get the hostname of the current environment
const hostname = window.location.hostname;
// Conditionally set the CFP URL based on the network type
export const cfpBaseUrl = hostname == '192.168.2.2'
    ? process.env.REACT_APP_CFP_PRIVATE_URL
    : process.env.REACT_APP_CFP_PUBLIC_URL;

export const wfsBaseUrl = hostname == '192.168.2.2'
    ? process.env.REACT_APP_WMS_PRIVATE_URL
    : process.env.REACT_APP_WMS_PUBLIC_URL

export const cpBaseUrl = process.env.REACT_APP_CP_API_URL

export const mnrURL = process.env.REACT_APP_MNR_URL

export const ptwBaseUrl = "https://ptw.pitc.com.pk"
export const ptwToken = "Bearer LBTQgBxiSF89ZrDimMadiJFnD-1RrdJQRluDeDL57BkesJvZEKKgxWtfaqv9Ykhk5AsjDG6J3atxHDEVQsG7OBFZRXdvMVlaJReu7PrqT6hKpxr754Qg83erIhsi4StWrsrPsA2jbhP0RAGzENkEBvoAfy1tgIrNYkzLj2vwoFER2okTUN-tbPNDLeNpImFRAjuuUtxlSztqtZ44YObcrmjb705FdlzumTxJoc779mlrV3V4OoM_dgl2YJCSX56TSHrnb6l2BMiwNj_RlxZht7ldJHJVWvS2nx-lMe-OREA"

// export const eopsApiBaseUrl = "https://eopsapi.pitc.com.pk/"